import { useEffect, useState } from "react";

import ActiveCallDetail from "./components/ActiveCallDetail";
import Button from "./components/base/Button";
import Vapi from "@vapi-ai/web";
import wave from "../src/Images/waves-bg-n.png";
import footerLogo from "../src/Images/superbuter-logo-whiteicon-ai.png";
import { isPublicKeyMissingError } from "./utils";
import { useParams } from "react-router-dom";
// import useStayAwake from "use-stay-awake";
// const brightness = require('brightness');
const isProduction = true
// Put your Vapi Public Key below.
// const vapi = isProduction ? new Vapi("385d9875-3247-4aaf-ad82-f07d23de5985") : new Vapi("1c383d43-227f-4cea-b13a-4bf3a24287df");
const vapi = isProduction ? new Vapi("385d9875-3247-4aaf-ad82-f07d23de5985") : new Vapi("47417720-110d-4f62-a29e-c36003ab237a");
const assistanceArray = [
  {slug: "yourhotel", assistanceId: "d2b88b48-e0e0-486a-924d-ff450068e544", logo: "https://cdn-superbutler.s3.eu-west-1.amazonaws.com/images/000/019/000019605_yourhotel-logo-long.png"},
  {slug: "foodgala",  assistanceId: "d1efd122-cb19-442c-80e4-09ec895246ad", logo: "https://cdn-superbutler.s3.eu-west-1.amazonaws.com/images/000/018/000018733_foodgala-llc.jpg"},
  {slug: "pestana", assistanceId:   "88ac025d-3e5f-40bd-aee5-0a626c92356c", logo: "https://cdn-superbutler.s3.eu-west-1.amazonaws.com/images/000/017/000017135_horizontal-pestana.png"},
]

const DynamicAssistant = () => {
  const { slug } = useParams(); 
  const [connecting, setConnecting] = useState(false);
  const [connected, setConnected] = useState(false);
  const [assistantIsSpeaking, setAssistantIsSpeaking] = useState(false);
  const [volumeLevel, setVolumeLevel] = useState(0);
  const [isMuted, setIsMuted] = useState(false);
  const [hotelLogo, setHotelLogo] = useState(footerLogo);
  const [assistantId, setAssistantId] = useState('');
  const { showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage } = usePublicKeyInvalid();
  // const device = useStayAwake();
  // code for screen timeout starts
  const [wakeLock, setWakeLock] = useState(null);


  const requestWakeLock = async () => {
    if ('wakeLock' in navigator) {
      try {
        const lock = await navigator.wakeLock.request('screen');
        setWakeLock(lock);
        console.log( "Wake Lock active")
        lock.addEventListener('release', () => {
          console.log( "Wake Lock released")
        });
      } catch (err) {
        console.log("Failed to acquire Wake Lock")
      }
    } else {
      console.log("Wake Lock API is not supported in this browser")
    }
  };

  const releaseWakeLock = async () => {
    if (wakeLock) {
      try {
        await wakeLock.release(); // Ensure release completes
        setWakeLock(null); // Clear the state
        console.log('Wake Lock released manually');
      } catch (err) {
        console.log('Error releasing Wake Lock:', err);
      }
    }
  };

useEffect(() => {
  // Compute fallback slug without mutating the original
  const currentSlug = (!slug || slug.trim() === "") 
    ? "pestana" 
    : slug.toLowerCase();

  // Find the assistant object
  const assistantObj = assistanceArray.find(ai => ai.slug === currentSlug);

  // Only update state if different (avoids unnecessary re-renders)
  if (assistantObj) {
    setAssistantId(prev => prev !== assistantObj.assistanceId ? assistantObj.assistanceId : prev);
    setHotelLogo(prev => prev !== assistantObj.logo ? assistantObj.logo : prev);
  }
  
  // This will only trigger when `slug` changes
}, [slug, assistanceArray]);
  // hook into Vapi events
  useEffect(() => {
    vapi.on("call-start", () => {
      setConnecting(false);
      setConnected(true);
      setShowPublicKeyInvalidMessage(false);
      vapi.setMuted(false);
      requestWakeLock();
      if (!wakeLock) {
        console.log('Wake Lock state cleared.');
      }
    
    }, [wakeLock]);

    vapi.on("call-end", () => {
      setConnecting(false);
      setConnected(false);
      setShowPublicKeyInvalidMessage(false);
    });

    vapi.on("speech-start", () => {
      setAssistantIsSpeaking(true);
    });

    vapi.on("speech-end", () => {
      setAssistantIsSpeaking(false);
    });

    vapi.on("volume-level", (level) => {
      setVolumeLevel(level);
    });

    vapi.on("error", (error) => {
      console.error(error);

      setConnecting(false);
      if (isPublicKeyMissingError({ vapiError: error })) {
        setShowPublicKeyInvalidMessage(true);
      }
    });

    // we only want this to fire on mount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  // call start handler
  const startCallInline = () => {
    setConnecting(true);
    vapi.start(assistantId);
  };
  const endCall = () => {
    vapi.stop();
    releaseWakeLock();
  };

  const onUserSpeak = () =>{
    vapi.setMuted(false)
    setIsMuted(false) 
  }
  const onUserMicMute = () =>{
    vapi.setMuted(true)
    setIsMuted(true) 
  }

  return (
    <div className="body-m-wrap flex-1">   
    <div className="app-p-wrap flex-1">
      <div className="" style={{display:"flex", flexDirection:"column"}}>
    <div className="logo-m-wrap">
        <img src={hotelLogo} alt="Logo" />
      </div>
      <div className="voice-ai-text">
        <span>Voice AI Assistant</span>
        <div className="y-b-version">
        <span>Beta</span>
      </div>
      </div>
    <div className="d-margin-cen"
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        marginTop:"10px"
      }}
    >
      {!connected ? (
        <Button
          label="Give it a try"
          onClick={startCallInline}
          isLoading={connecting}
          assistantIsSpeaking={false} 
          isMuted={isMuted}
        />
      ) : (
        <ActiveCallDetail
          assistantIsSpeaking={assistantIsSpeaking}
          volumeLevel={volumeLevel}
          onEndCallClick={endCall}
          onUserSpeak={onUserSpeak}
          onUserMicMute={onUserMicMute}
          isMuted={isMuted}
        />
      )}

      {showPublicKeyInvalidMessage ? <PleaseSetYourPublicKeyMessage /> : null}
      {/* <ReturnToDocsLink /> */}
    </div>
    </div>
    <div className='pwrd-by-s-b'>
      {/* <span className="f-b-version">Beta Version</span> */}
      <div className="pwr-sec">
                  <span className='pwrd-by-s-b-i'>Powered by</span>
                  <img height={40} alt="footer" src={footerLogo} />
                  </div>
                </div>
    </div>
    
               
    </div>
  );
};


const usePublicKeyInvalid = () => {
  const [showPublicKeyInvalidMessage, setShowPublicKeyInvalidMessage] = useState(false);

  // close public key invalid message after delay
  useEffect(() => {
    if (showPublicKeyInvalidMessage) {
      setTimeout(() => {
        setShowPublicKeyInvalidMessage(false);
      }, 3000);
    }
  }, [showPublicKeyInvalidMessage]);

  return {
    showPublicKeyInvalidMessage,
    setShowPublicKeyInvalidMessage,
  };
};

const PleaseSetYourPublicKeyMessage = () => {
  return (
    <div
      style={{
        position: "fixed",
        bottom: "25px",
        left: "25px",
        padding: "10px",
        color: "#fff",
        backgroundColor: "#f03e3e",
        borderRadius: "5px",
        boxShadow: "0 2px 5px rgba(0,0,0,0.2)",
      }}
    >
      Is your Vapi Public Key missing? (recheck your code)
    </div>
  );
};

export default DynamicAssistant;
